import React from 'react'
import styled from 'styled-components'
import { Box, Flex, Link, Text } from 'pcln-design-system'
import { Cars, Flights, Hotels } from 'pcln-icons'
import analytics from '../../utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '../../constants/analytics'

const ViewTripLink = styled(Link)`
  padding-left: 16px;
  font-size: 14px;
  font-weight: normal;
`
const trackViewTripClick = () => {
  analytics.fireEvent({
    action: 'Feature Box Link',
    category: ANALYTICS_CATEGORY_HOME,
    label: 'Cross Sell View Trip'
  })
}

type ProductIcon = typeof Flights | typeof Cars | typeof Hotels

const getProductIcon = (product: string): ProductIcon => {
  switch (product) {
    case 'flight':
      return Flights
    case 'car':
      return Cars
    default:
      return Hotels
  }
}

type TripDetailsBoxProps = {
  product: string
  headline: string
  subHeadline: string
}

function TripDetailsBox({
  product,
  headline,
  subHeadline
}: TripDetailsBoxProps) {
  const ProductIcon = getProductIcon(product || 'hotel')
  return (
    <Flex ml={-2} alignItems="center">
      <ProductIcon color="primary.dark" size="56" mr={2} />
      <Box ml={1}>
        <Text
          color="text"
          fontSize={[2, null, null, 3]}
          mb={1}
          fontWeight="bold"
        >
          {headline}{' '}
          <ViewTripLink href="/profile/#/mytrips" onClick={trackViewTripClick}>
            View Trip
          </ViewTripLink>
        </Text>
        <Text color="text" fontSize={[1, null, null, 2]} mt={1}>
          {subHeadline}
        </Text>
      </Box>
    </Flex>
  )
}

export default TripDetailsBox
